"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScheduleType;
(function(ScheduleType) {
  ScheduleType["RATE"] = "rate";
  ScheduleType["CRON"] = "cron";
  ScheduleType["PARSED_CRON"] = "parsed-cron";
})((ScheduleType = exports.ScheduleType || (exports.ScheduleType = {})));
var ViewType;
(function(ViewType) {
  ViewType["SCHEDULE"] = "schedule";
  ViewType["HTTP"] = "http";
  ViewType["ALARM"] = "alarm";
  ViewType["EVENTS"] = "events";
  ViewType["Manual"] = "manual";
})((ViewType = exports.ViewType || (exports.ViewType = {})));
var FilterType;
(function(FilterType) {
  FilterType["PARAM"] = "param";
  FilterType["DATE_FILTER"] = "date-filter";
  FilterType["TAG"] = "tag";
  FilterType["SG_RULE"] = "sg_rule";
  FilterType["NACL_RULE"] = "nacl-rule";
  FilterType["FUNCTION"] = "function";
})((FilterType = exports.FilterType || (exports.FilterType = {})));
var NotificationType;
(function(NotificationType) {
  NotificationType["EMAIL"] = "email";
  NotificationType["SLACK"] = "slack";
  NotificationType["NONE"] = "none";
})(
  (NotificationType =
    exports.NotificationType || (exports.NotificationType = {}))
);
var HttpMethodType;
(function(HttpMethodType) {
  HttpMethodType["GET"] = "GET";
  HttpMethodType["POST"] = "POST";
  HttpMethodType["PUT"] = "PUT";
  HttpMethodType["DELETE"] = "DELETE";
})((HttpMethodType = exports.HttpMethodType || (exports.HttpMethodType = {})));
var DataFormatterOptionType;
(function(DataFormatterOptionType) {
  DataFormatterOptionType["DATA"] = "data";
  DataFormatterOptionType["OBJ"] = "obj";
})(
  (DataFormatterOptionType =
    exports.DataFormatterOptionType || (exports.DataFormatterOptionType = {}))
);
//# sourceMappingURL=NodeDataTypes.js.map
